// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"vendors-node_modules_gsap_CSSPlugin_js":"57fb40fdc8ec2604219d","components_anchor-menu_anchor-menu_js":"fb169fb08c774e0cc2c6"}[chunkId] + ".min.js";
};